import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export default function BrandMarquee() {
  const { t } = useLang();
  const items = t.marquee;
  return (
    <section className="relative border-y border-line py-8 md:py-10 bg-bg-2/40 overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-head font-extrabold tracking-tight text-[clamp(2rem,6vw,5rem)] px-8 ${
                i % 2 === 0 ? "text-ink" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="text-brand text-[clamp(2rem,6vw,5rem)] px-4">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
